import React, { useState } from "react";
import {
  Divider,
  IconButton,
  Badge,
  Menu,
  MenuItem,
  Popover,
  Tooltip,
} from "@mui/material";
import EmployeeExitRequestDialog from "./EmployeeExitRequestDialog";
import { connect, useDispatch } from "react-redux";

import {
  stopActing,
  getEmployeeBankAccounts,
  getEmployeeProfile,
  getEmployeePromotions,
  doVerifyRSSBNumber,
  doVerifyNIDNumber,
} from "../../../store/structure/actions";
import types from "../../../store/common/action-types";
import { downloadEmployeeDeductionsReport } from "../../../store/payroll/actions";

import { getSingleActiveContract } from "../../../store/contractuals/actions";
import { getEmployeeExitRequest } from "../../../store/exit/actions";
import { getCase } from "../../../store/discipline/actions";
import { getRecruitmentRequest, getEmployeeOrApplicationRecruitmentRequests } from "../../../store/recruitment/actions";
import { getSelectedEmployeeProfilePicture } from "../../../store/common/actions";
import PreviewEmployeePaySlipDialog from "./PreviewEmployeePaySlipDialog";
import EmployeePayHistoryDialog from "./EmployeePayHistoryDialog";
import EmployeeSalarySettingsDialog from "./EmployeeSalarySettingsDialog";
import EmployeePromotionDialog from "./EmployeePromotionDialog";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import { currencyFormat } from "../../common/components/Utils";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import EmployeePBFSettingsDialog from "./EmployeePBFSettingsDialog";
import UserResume from "../../profile/UserResume";
import EmployeeSubordinatesDialog from "../../rbm/components/EmployeeSubordinatesDialog";
import ApproveExitDialog from "../../exit/components/ApproveExitDialog";
import NewDisplinarlyCaseRequestDialog from "../../discipline/components/NewDisplinarlyCaseRequestDialog";
import ViewCaseDialog from "../../discipline/components/ViewCaseDialog";
import NewExitRequestDialog from "./NewExitRequestDialog";
import ViewExitDialog from "../../exit/components/ViewExitDialog";
import HiddenText from "../../common/components/HiddenText";
import moment from "moment";
import ViewSpecialSupervisorDialog from "../../discipline/components/ViewSpecialSupervisorDialog";
import WidgetViewContentDialog from "../../common/components/WidgetViewContentDialog";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ViewApplicationEmploymentAttachments from "../../recruitment/components/ViewApplicationEmploymentAttachments";
import NewRecruitmentRequestDialog from "../../recruitment/components/NewRecruitmentRequestDialog";
import ApproveRecruitmentRequestDialog from "../../recruitment/components/ApproveRecruitmentRequestDialog";
import { handleAdministrationLetterRequest } from "../../recruitment/utils/administrationLetterUtils";

const EmployeeCard = (props) => {
  const {
    loading,
    showInstitutionName,
    employee,
    employeeIndex,
    showUnitName,
    stopActing,
    getEmployeeBankAccounts,
    getEmployeePromotions,
    getSelectedEmployeeProfilePicture,
    getSingleActiveContract,
    selectedUnit,
    getEmployeeExitRequest,
    downloadEmployeeDeductionsReport,
    doVerifyRSSBNumber,
    doVerifyNIDNumber,
    getCase,
    getRecruitmentRequest,
    env,
    showBRDTotalRecovery = true,
    handleUnlockAccount,
    handleSetPullLeavePlan,
    getEmployeeOrApplicationRecruitmentRequests,
  } = props;

  const [showEmployeeProfileDialog, setShowEmployeeProfileDialog] =
    useState(false);
  const [showEmployeeExitForm, setShowEmployeeExitForm] = useState(false);
  const [showPendingEmployeeExit, setShowPendingEmployeeExit] = useState(false);
  const [showEmployeePaySlip, setShowEmployeePaySlip] = useState(false);
  const [showEmployeePayHistory, setShowEmployeePayHistory] = useState(false);
  const [showEmployeeSubordinates, setShowEmployeeSubordinates] =
    useState(false);
    const [documentDialog, setDocumentDialog] = useState(false);
  const [
    showNewDisplinarlyCaseRequestDialog,
    setShowNewDisplinarlyCaseRequestDialog,
  ] = useState(false);
  const [showCaseDetail, setShowCaseDetail] = useState(false);
  const [isLoading, setShowIsLoading] = useState(false);
  const [showRequestForm, setShowRequestForm] = useState(false);
  const [approveRequestForm, setApproveRequestForm] = useState(false);
  const [initiateLetterCustomization, setInitiateLetterCustomization] =
    useState(null);
  // const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showPBFSettingsDialog, setShowPBFSettingsDialog] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [administrationLetterAnchorEl, setAdministrationLetterAnchorEl] =
    useState(null);
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const administrationLetterOpen = Boolean(administrationLetterAnchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setAdministrationLetterAnchorEl(null);
  };

  const handleOpenAdministrationLetterPopover = (event) => {
    setAdministrationLetterAnchorEl(event.currentTarget);
  };

  const handleCloseAdministrationLetterPopover = () => {
    setAdministrationLetterAnchorEl(null);
  };

  const checkDisabled = (employee) => {
    if (employee.isShared === true) return true;
    else return false;
  };

  const borderColor = (employee) => {
    let borderColor = "";
    if (employee.statusId !== 0 && !employee.isActing) {
      borderColor = "danger";
    }
    if (employee.hasExitApproved && employee.statusId === 0) {
      borderColor = "info";
    }

    if (employee.isShared || employee.isSharing) {
      borderColor = "primary";
    }
    if (
      !employee.positionId ||
      !employee.idNumber ||
      (!!employee.idNumber &&
        (employee.idNumber || "").replace(/\s/g, "").length !== 16) ||
      !employee.rssbNumber ||
      !employee.phoneNumber ||
      !employee.email
    ) {
      borderColor = "danger";
    }

    return borderColor;
  };

  const [showSalarySettingsDialog, setShowSalarySettingsDialog] =
    useState(false);

  const [showEmployeePromotionsDialog, setShowEmployeePromotionsDialog] =
    useState(false);

  const [confirmStopActing, setConfirmStopActing] = useState(false);
  const [specialSupervisors, setSpecialSupervisors] = useState(false);
  const { hasPermissions } = useRequiredAuth();

  const [isRSSBVerifying, setIsRSSBVerifying] = useState(false);
  const [isNIDVerifying, setIsNIDVerifying] = useState(false);
  const [recruitmentRequests, setRecruitmentRequests] = useState([]);
  const [isLoadingRecruitmentRequests, setIsLoadingRecruitmentRequests] = useState(false);
  // console.log(employee);
  return (
    <>
      <tr className={`text-${borderColor(employee)}`}>
        <th scope="row" style={{ backgroundColor: "#f0f2f5" }}>
          {employeeIndex + 1}
        </th>
        <td> {employee.id}</td>
        <td>
          {employee.lastName} {employee.firstName}
        </td>
        <td>
          <span className="d-flex align-items-center justify-content-between">
            {(employee.idNumber || "").replace(/ /g, "")}
            <Tooltip
              title={`${employee.nidVerified ? "Verified" : "Not Verified"} `}
            >
              <span style={{ cursor: "pointer" }}>
                <IconButton
                  disabled={isNIDVerifying}
                  className="p-1"
                  size="small"
                  onClick={() => doVerifyNIDNumber(employee, setIsNIDVerifying)}
                >
                  {employee.nidVerified && !isNIDVerifying && (
                    <span
                      className="material-icons text-success"
                      style={{ fontSize: "12px" }}
                    >
                      verified
                    </span>
                  )}
                  {!employee.nidVerified && !isNIDVerifying && (
                    <span
                      className="material-icons text-danger"
                      style={{ fontSize: "12px" }}
                    >
                      warning
                    </span>
                  )}

                  {isNIDVerifying && (
                    <i
                      className="fas fa-spinner loader2"
                      style={{ fontSize: "12px" }}
                    ></i>
                  )}
                </IconButton>
              </span>
            </Tooltip>
          </span>
        </td>

        <td style={{ width: "84px" }}>
          <span className="d-flex align-items-center justify-content-between">
            {employee.rssbNumber}
            <Tooltip
              title={`${employee.rssbVerified ? "Verified" : "Not Verified"} `}
            >
              <span style={{ cursor: "pointer" }}>
                <IconButton
                  disabled={isRSSBVerifying}
                  className="p-1"
                  size="small"
                  onClick={() =>
                    doVerifyRSSBNumber(employee, setIsRSSBVerifying)
                  }
                >
                  {employee.rssbVerified && !isRSSBVerifying && (
                    <span
                      className="material-icons text-success"
                      style={{ fontSize: "12px" }}
                    >
                      verified
                    </span>
                  )}
                  {!employee.rssbVerified && !isRSSBVerifying && (
                    <span
                      className="material-icons text-danger"
                      style={{ fontSize: "12px" }}
                    >
                      warning
                    </span>
                  )}

                  {isRSSBVerifying && (
                    <i
                      className="fas fa-spinner loader2"
                      style={{ fontSize: "12px" }}
                    ></i>
                  )}
                </IconButton>
              </span>
            </Tooltip>
          </span>
        </td>
        <td>
          {employee.isActing && (
            <strong
              className="text-primary"
              style={{ fontSize: ".75rem", fontweight: "bold" }}
            >
              Ag.
            </strong>
          )}
          {employee.positionName}{" "}
          {employee.isRISASharedStaff &&
            (selectedUnit.unitId === "1903000000-150200000000000000" ||
              selectedUnit.unitId === "1903000000-150201000000000000") && (
              <span>({employee.entityName})</span>
            )}
          {!!employee.tmisRole && (
            <span className="d-block">
              <span
                className={`badge badge-${
                  ["HEADTEACHER", "DEPUTY_HEADTEACHER"].includes(
                    employee.tmisRole
                  )
                    ? "success"
                    : employee.tmisRole === "TEACHER"
                    ? "primary"
                    : "secondary"
                }`}
                style={{ borderRadius: "0px" }}
              >
                {employee.tmisRole} ({employee.teacherQualification})
              </span>
            </span>
          )}
        </td>
        {showUnitName && <td>{employee.unitName}</td>}
        {showInstitutionName && <td>{employee.institutionName}</td>}
        <td className="text-right">
          <span className="d-flex align-items-center justify-content-end">
            {employee.levelName}.{employee.scaleName}
            {!!employee.verticalRank && (
              <Tooltip title={employee.verticalRank}>
                <i className="fas fa-briefcase ml-1 cursor-pointer text-primary"></i>
              </Tooltip>
            )}
          </span>
        </td>
        <td className="text-right">{employee.index || 0}</td>
        <td className="text-right">{employee.indexValue || 0}</td>

        <td className="text-right" style={{ backgroundColor: "#e9ecef" }}>
          <HiddenText
            value={currencyFormat(
              (employee.indexValue || 0) * (employee.index || 0)
            )}
          />
        </td>
        {!!showBRDTotalRecovery && (
          <>
            <td className="text-right" style={{ backgroundColor: "#e9ecef" }}>
              {!!employee.totalLoanAmount ? (
                <span
                  className={`d-flex align-items-center justify-content-end text-right text-${
                    +employee.remainingLoanAmount <= 0 ? "success" : "danger"
                  }`}
                >
                  {" "}
                  {(+(
                    ((employee?.totalPaidAmount || 0) * 100) /
                    (employee?.totalLoanAmount || 1)
                  ) > 100.0
                    ? 100
                    : (((employee?.totalPaidAmount || 0) * 100) /
                        (employee?.totalLoanAmount || 1)) *
                      1.0
                  ).toFixed(0)}
                  %
                  {+employee.remainingLoanAmount <= 0 && (
                    <span
                      className="material-icons text-success"
                      style={{ fontSize: "12px" }}
                    >
                      verified
                    </span>
                  )}
                </span>
              ) : (
                <>-</>
              )}
            </td>
          </>
        )}

        {!!employee.employeeGroupName && (
          <td
            className="text-center"
            style={{
              maxWidth: "96px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {employee.employeeGroupName}
          </td>
        )}

        <td className="text-right">
          {!!employee.isActing && (
            <strong
              className="badge badge-primary"
              style={{ fontSize: ".75rem", fontweight: "bold" }}
            >
              Acting
            </strong>
          )}

          {!employee.isActing && (
            <strong
              className={`ml-1 badge badge-${
                employee.statusId === 0 && !employee.isSecondary
                  ? "success"
                  : employee.isSecondary
                  ? "secondary"
                  : "warning"
              }`}
              style={{ fontSize: ".75rem", fontweight: "bold" }}
            >
              {!!employee.isSecondary ? "Second" : employee.statusName}
            </strong>
          )}

          {!!employee.hasExitApproved &&
            employee.statusId === 0 &&
            !!employee.exitEffectiveDate && (
              <>
                {" "}
                <br />
                <small
                  className="ml-1 text text-danger w-100"
                  style={{ fontSize: "10px", fontweight: "bold" }}
                >
                  Exit will be Effected:{" "}
                  {moment(employee.exitEffectiveDate).format("LL")}
                </small>
              </>
            )}

          {!!employee.hasPendingExitRequest && (
            <>
              <br />
              <small
                className="ml-1 text text-danger w-100"
                style={{ fontSize: "10px", fontweight: "bold" }}
              >
                Exit request in progress.
              </small>
            </>
          )}
          {!!employee.hasPendingDisciplinaryCase && (
            <>
              <br />
              <small
                className="ml-1 text text-warning w-100"
                style={{ fontSize: "10px", fontweight: "bold" }}
              >
                Case in progress
              </small>
            </>
          )}
        </td>
        <td>
          <IconButton
            size="small"
            className="ml-2"
            onClick={handleOpenMenu}
            // onMouseMove={handleOpenMenu}
            aria-label="settings"
          >
            <Badge color="info">
              <span className="material-icons">more_vert</span>
            </Badge>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleCloseMenu}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "auto",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 2,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 15,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <span>
              <MenuItem
                disabled={loading}
                onClick={() => {
                  handleCloseMenu();
                  // setSelectedEmployee(employee);
                  setShowEmployeeProfileDialog(true);
                  dispatch({
                    type: types.SET_USER_PROFILE,
                    data: {
                      ...employee,
                      employments: [
                        {
                          positionName: employee.positionName,
                          employeeGroupId: employee.employeeGroupId,
                          levelName: employee.levelName,
                          scaleName: employee.scaleName,
                          entityName: employee.entityName,
                          unitName: employee.unitName,
                          isActing: employee.isActing,
                          startDate: employee.startDate,
                          id: employee.employeePositionId,
                        },
                      ],
                    },
                  });
                }}
                className="text-dark font-weight-bold text-primary"
              >
                <span className="material-icons mr-1">open_in_new</span>
                Profile
              </MenuItem>
              <Divider className="my-1" />
            </span>

            {((!checkDisabled(employee) && !employee.isRISASharedStaff) ||
              (employee.isRISASharedStaff &&
                (selectedUnit.unitId === "1903000000-150200000000000000" ||
                  selectedUnit.unitId ===
                    "1903000000-150201000000000000"))) && (
              <span>
                <MenuItem
                  disabled={loading || !hasPermissions(["IS_HR"])}
                  onClick={() => {
                    getSelectedEmployeeProfilePicture(employee.idNumber);

                    getSingleActiveContract(employee.employeePositionId);

                    getEmployeeBankAccounts(
                      employee.id,
                      setShowSalarySettingsDialog,
                      handleCloseMenu
                    );
                  }}
                  className="text-dark font-weight-light"
                >
                  <span className="material-icons mr-1">tune</span>
                  Salary settings
                </MenuItem>
                <Divider className="my-1" />
              </span>
            )}

            {!checkDisabled(employee) && (
              <span>
                <MenuItem
                  disabled={loading || !hasPermissions(["IS_HR"])}
                  onClick={() => {
                    setShowPBFSettingsDialog(employee);
                    handleCloseMenu();
                  }}
                  className="text-dark font-weight-light"
                >
                  {/* <span className="material-icons mr-1 ">logout</span> */}
                  <span className="material-icons-outlined mr-1">
                    settings_suggest
                  </span>
                  PBF Settings
                </MenuItem>
                <Divider className="my-1" />
              </span>
            )}

            {((!checkDisabled(employee) && !employee.isRISASharedStaff) ||
              (employee.isRISASharedStaff &&
                (selectedUnit.unitId === "1903000000-150200000000000000" ||
                  selectedUnit.unitId ===
                    "1903000000-150201000000000000"))) && (
              <span>
                <MenuItem
                  disabled={
                    loading ||
                    employee.statusId === 30 ||
                    !hasPermissions(["IS_HR"])
                  }
                  onClick={() => {
                    getEmployeePromotions(
                      employee.employeePositionId,
                      setShowEmployeePromotionsDialog,
                      handleCloseMenu
                    );
                  }}
                  className="text-dark font-weight-light"
                >
                  <span className="material-icons mr-1">moving</span>
                  Promotions
                </MenuItem>
                <Divider className="my-1" />
              </span>
            )}

            {!checkDisabled(employee) && (
              <span>
                <MenuItem
                  disabled={loading || !hasPermissions(["IS_HR"])}
                  onClick={() => {
                    handleCloseMenu();
                    //setSelectedEmployee(employee);
                    setShowEmployeePayHistory(true);
                  }}
                  className="text-dark font-weight-light"
                >
                  <span className="material-icons mr-1">payments</span>
                  Pay history
                </MenuItem>
                <Divider className="my-1" />
              </span>
            )}

            <span>
              <MenuItem
                disabled={loading || !hasPermissions(["IS_HR"])}
                onClick={() => {
                  downloadEmployeeDeductionsReport(
                    employee.id,
                    handleCloseMenu
                  );
                }}
                className="text-dark font-weight-light"
              >
                <span className="material-icons mr-1">download</span>
                Deductions report
              </MenuItem>
              <Divider className="my-1" />
            </span>

            {!!employee.isHeadOfUnit && (
              <span>
                <MenuItem
                  disabled={loading}
                  onClick={() => {
                    handleCloseMenu();
                    setShowEmployeeSubordinates(true);
                  }}
                  className="text-dark font-weight-light"
                >
                  <span className="material-icons mr-1">group</span>
                  Subordinates
                </MenuItem>
                <Divider className="my-1" />
              </span>
            )}

            {!checkDisabled(employee) && employee.isActing && (
              <span>
                <MenuItem
                  disabled={
                    loading ||
                    employee.statusId === 30 ||
                    !hasPermissions(["IS_HR"])
                  }
                  onClick={() => {
                    handleCloseMenu();

                    setConfirmStopActing(true);
                  }}
                  style={{ color: "#ba931e" }}
                  className="font-weight-light"
                >
                  <span className="material-icons mr-1">
                    cancel_presentation
                  </span>
                  Stop acting
                </MenuItem>
                <Divider className="my-1" />
              </span>
            )}

            {/* {env !== "prod" && ( */}
            <span>
              <MenuItem
                disabled={
                  loading ||
                  employee.statusId === 30 ||
                  isLoading ||
                  !hasPermissions(["IS_HR"])
                }
                onClick={() => {
                  if (!!employee.hasPendingDisciplinaryCase) {
                    getCase(
                      employee.disciplinaryCaseId,
                      setShowIsLoading,
                      setShowCaseDetail
                    );
                  } else {
                    setShowNewDisplinarlyCaseRequestDialog(true);
                  }
                  handleCloseMenu();
                }}
                // style={{ color: "rgb(105 0 0)" }}
                className={
                  employee.hasPendingDisciplinaryCase
                    ? "text-warning font-weight-light text-danger"
                    : "font-weight-light"
                }
              >
                <span className="material-icons mr-1 ">
                  {" "}
                  {employee.hasPendingDisciplinaryCase ? "visibility" : "add"}
                </span>
                {isLoading ? "Wait..." : "Disciplinary Case"}
              </MenuItem>
              <Divider className="my-1" />
            </span>
            {/* )} */}

            {((!checkDisabled(employee) && !employee.isRISASharedStaff) ||
              (employee.isRISASharedStaff &&
                (selectedUnit.unitId === "1903000000-150200000000000000" ||
                  selectedUnit.unitId === "1903000000-150201000000000000"))) &&
              +employee.statusId === 0 && (
                <span>
                  <MenuItem
                    disabled={loading}
                    onClick={() => {
                      getEmployeeExitRequest(
                        employee.employeePositionId,
                        employee.exitRequestId || 0,
                        employee.hasPendingExitRequest ||
                          employee.hasExitApproved
                          ? setShowPendingEmployeeExit
                          : setShowEmployeeExitForm,
                        handleCloseMenu
                      );
                    }}
                    className={
                      employee.hasExitApproved
                        ? "font-weight-light text-success"
                        : employee.hasPendingExitRequest
                        ? "font-weight-light text-danger"
                        : "font-weight-light text-warning"
                    }
                  >
                    <span className="material-icons mr-1 ">logout</span>
                    {employee.hasExitApproved
                      ? "View Approved Exit"
                      : employee.hasPendingExitRequest
                      ? "View Pending Exit"
                      : "Request Exit"}
                  </MenuItem>
                </span>
              )}

            {!checkDisabled(employee) &&
              +employee.statusId === 0 &&
              !!handleUnlockAccount && (
                <span>
                  <Divider className="my-1" />
                  <MenuItem
                    disabled={loading}
                    onClick={() => {
                      handleUnlockAccount(employee.id);
                    }}
                    className="font-weight-light text-danger"
                  >
                    <span className="material-icons mr-1">key_off</span>
                    UnLock Account
                  </MenuItem>
                </span>
              )}

            {!checkDisabled(employee) &&
              +employee.statusId === 0 &&
              !!handleSetPullLeavePlan && (
                <span>
                  <Divider className="my-1" />
                  <MenuItem
                    disabled={loading}
                    onClick={() => {
                      handleSetPullLeavePlan(employee);
                    }}
                    className="font-weight-light text-primary"
                  >
                    <span className="material-icons mr-1">play_for_work</span>
                    Pull Annual Leave
                  </MenuItem>
                </span>
              )}

            {!checkDisabled(employee) && (
              <span>
                <Divider className="my-1" />
                <MenuItem
                  disabled={
                    loading ||
                    employee.statusId === 30 ||
                    !hasPermissions(["IS_HR"])
                  }
                  onClick={() => {
                    handleCloseMenu();

                    setSpecialSupervisors(true);
                  }}
                  // style={{ color: "#ba931e" }}
                  className="font-weight-light"
                >
                  <span className="material-icons mr-1">diversity_2</span>
                  Special Supervisors
                </MenuItem>
              </span>
            )}     

            <span>
              <Divider className="my-1" />
              <MenuItem
                disabled={!hasPermissions(["IS_HR"])}
                onClick={(event) => {
                  const anchorTarget = event.currentTarget;
                  setIsLoadingRecruitmentRequests(true);
                  getEmployeeOrApplicationRecruitmentRequests(employee.employeePositionId, undefined, (data) => {
                    setRecruitmentRequests(data);
                    setIsLoadingRecruitmentRequests(false);
                    handleOpenAdministrationLetterPopover({ currentTarget: anchorTarget });
                  });
                }}
                className="text-dark font-weight-light"
              >
                <span className="material-icons mr-1 text-primary">article</span>
               {isLoadingRecruitmentRequests ? 'Wait...' : 'Administration Letter'}
              </MenuItem>
            </span>

            <MenuItem
                  disabled={
                    !hasPermissions(["IS_HR"])
                  }
                  onClick={() => {
                    handleCloseMenu();
                    setDocumentDialog(true);
                  }}
                  className="text-dark font-weight-light"
                >
                  <AttachFileIcon className="mr-2 text-primary" />

                  <>Attachments</>
                </MenuItem>
          </Menu>
          <Popover
            open={administrationLetterOpen}
            anchorEl={administrationLetterAnchorEl}
            onClose={handleCloseAdministrationLetterPopover}
            anchorOrigin={{ vertical: "center", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
          >
            <MenuItem
              onClick={() => {
                handleCloseAdministrationLetterPopover();
                handleCloseMenu();
                setInitiateLetterCustomization({ requestTypeId: 1 });
                setShowRequestForm(true);
              }}
              className="text-dark font-weight-light"
            >
              Provisional Appoint. Letter
            </MenuItem>
            <Divider className="my-1" />
            <MenuItem
              onClick={() => {
                handleCloseAdministrationLetterPopover();
                handleCloseMenu();
                setInitiateLetterCustomization({ requestTypeId: 2 });
                setShowRequestForm(true);
              }}
              className="text-dark font-weight-light"
            >
              Appointment Letter
            </MenuItem>
            <Divider className="my-1" />
            <MenuItem
              onClick={() => {
                handleCloseAdministrationLetterPopover();
                handleCloseMenu();
                setInitiateLetterCustomization({ requestTypeId: 3 });
                setShowRequestForm(true);
              }}
              className="text-dark font-weight-light"
            >
              Confirmation Letter
            </MenuItem>
          </Popover>
        </td>
      </tr>
      {documentDialog && (
        <WidgetViewContentDialog
          openDialog={documentDialog}
          maxWidth="md"
          content={
            <>
              <ViewApplicationEmploymentAttachments
                employeePositionId={employee.employeePositionId}
                canEdit={hasPermissions(["IS_HR"])}
              />
            </>
          } 
          title={<>View Employee Documents</>}
          setOpenDialog={setDocumentDialog}
        />
      )}
      {showRequestForm && (
        <NewRecruitmentRequestDialog
          showRequestForm={showRequestForm}
          setShowRequestForm={setShowRequestForm}
          selectedApplication={employee}
          initiateLetterCustomization={initiateLetterCustomization}
          letterNo={recruitmentRequests?.letterNumber}
          requestTypes={recruitmentRequests?.requestTypes}
          recruitmentRequests={recruitmentRequests}

        />
      )}
      {!!approveRequestForm && (
        <ApproveRecruitmentRequestDialog
          approveRequestForm={approveRequestForm}
          setApproveRequestForm={setApproveRequestForm}
          selectedRequest={employee}
        />
      )}

      {showEmployeeProfileDialog && (
        <UserResume
          showProfileDialog={showEmployeeProfileDialog}
          setShowProfileDialog={setShowEmployeeProfileDialog}
          canEdit={hasPermissions(["IS_HR"])}
          allowedToEditEmail={hasPermissions(["IS_HR"])}
          allowedToEditEmploymentDate={hasPermissions(["IS_HR"])}
        />
      )}

      {showSalarySettingsDialog && (
        <EmployeeSalarySettingsDialog
          showSalarySettingsDialog={showSalarySettingsDialog}
          setShowSalarySettingsDialog={setShowSalarySettingsDialog}
          employee={employee}
        />
      )}

      {showPBFSettingsDialog && (
        <EmployeePBFSettingsDialog
          showPBFSettingsDialog={showPBFSettingsDialog}
          setShowPBFSettingsDialog={setShowPBFSettingsDialog}
          employee={employee}
        />
      )}

      {showEmployeePromotionsDialog && (
        <EmployeePromotionDialog
          showEmployeePromotionsDialog={showEmployeePromotionsDialog}
          setShowEmployeePromotionsDialog={setShowEmployeePromotionsDialog}
          employee={employee}
        />
      )}

      {showEmployeePaySlip && (
        <PreviewEmployeePaySlipDialog
          showEmployeePaySlip={showEmployeePaySlip}
          setShowEmployeePaySlip={setShowEmployeePaySlip}
          selectedEmployee={employee}
          // setSelectedEmployee={setSelectedEmployee}
        />
      )}

      {!!showEmployeeExitForm && (
        <NewExitRequestDialog
          showEmployeeExitForm={showEmployeeExitForm}
          setShowEmployeeExitForm={setShowEmployeeExitForm}
          selectedEmployee={employee}
        />
      )}

      {/* {!!showEmployeeExitForm &&
        (employee.employeeGroupId === 6 ||
          employee.isAdministrativeDocumentDisabled === 1) && (
          <EmployeeExitRequestDialog
            showEmployeeExitForm={showEmployeeExitForm}
            setShowEmployeeExitForm={setShowEmployeeExitForm}
            selectedEmployee={employee}
          />
        )} */}

      {/* {!!showPendingEmployeeExit &&
        (employee.employeeGroupId === 6 ||
          employee.isAdministrativeDocumentDisabled === 1) && (
          <ApproveExitDialog
            approveRequestForm={showPendingEmployeeExit}
            setApproveRequestForm={setShowPendingEmployeeExit}
          />
        )} */}

      {!!showPendingEmployeeExit && (
        <ViewExitDialog
          approveRequestForm={showPendingEmployeeExit}
          setApproveRequestForm={setShowPendingEmployeeExit}
        />
      )}

      {showEmployeePayHistory && (
        <EmployeePayHistoryDialog
          selectedEmployee={employee}
          showEmployeePayHistory={showEmployeePayHistory}
          setShowEmployeePayHistory={setShowEmployeePayHistory}
        />
      )}

      {confirmStopActing && (
        <ConfirmationDialog
          confirmationDialog={confirmStopActing}
          message={`Are you sure you want to stop acting of  \n ${employee.lastName}  ${employee.firstName}?`}
          setConfirmationDialog={setConfirmStopActing}
          onYes={() => {
            stopActing(
              {
                employeePositionId: employee.employeePositionId,
              },
              setConfirmStopActing
            );
          }}
        />
      )}

      {showEmployeeSubordinates && (
        <EmployeeSubordinatesDialog
          supervisor={employee}
          onClose={() => setShowEmployeeSubordinates(false)}
        />
      )}

      {showNewDisplinarlyCaseRequestDialog && (
        <NewDisplinarlyCaseRequestDialog
          isInitiatedBySupervisor={0}
          showNewDisplinarlyCaseRequestDialog={
            showNewDisplinarlyCaseRequestDialog
          }
          setShowNewDisplinarlyCaseRequestDialog={
            setShowNewDisplinarlyCaseRequestDialog
          }
          employee={employee}
          isFirstCategory={false}
          setShowCaseDetail={setShowCaseDetail}
        />
      )}

      {showCaseDetail && (
        <ViewCaseDialog
          showCaseDetail={showCaseDetail}
          setShowCaseDetail={setShowCaseDetail}
        />
      )}

      {specialSupervisors && (
        <ViewSpecialSupervisorDialog
          employee={employee}
          onClose={setSpecialSupervisors}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ loading, env, user }) => {
  return {
    loading,
    env,
    user,
    selectedEntitySector: user.selectedEntitySector,
  };
};

export default connect(mapStateToProps, {
  stopActing,
  getEmployeeBankAccounts,
  getEmployeeProfile,
  getEmployeePromotions,
  getSelectedEmployeeProfilePicture,
  getSingleActiveContract,
  getEmployeeExitRequest,
  downloadEmployeeDeductionsReport,
  doVerifyRSSBNumber,
  doVerifyNIDNumber,
  getCase,
  getRecruitmentRequest,
  getEmployeeOrApplicationRecruitmentRequests
})(EmployeeCard);
